export default __webpack_public_path__ + "static/media/kitchen3-afterK-1920w.63e3d814.png";